import React, { useEffect } from 'react';
import useToolStore, { TOOL_TYPES } from '../../../store/useToolStore';
import { generateCode } from '../../../utils/codeGenerators';
import PhotoPickerPreview from './PhotoPickerPreview';
import PhotoPickerControls from './PhotoPickerControls';

const PhotoPickerGenerator = () => {
  const config = useToolStore((state) => state.toolConfigs[TOOL_TYPES.PHOTO_PICKER]);
  const updateConfig = useToolStore((state) => state.updateToolConfig);
  const setGeneratedCode = useToolStore((state) => state.setGeneratedCode);

  useEffect(() => {
    const code = generateCode(TOOL_TYPES.PHOTO_PICKER, config);
    setGeneratedCode(code);
  }, [config, setGeneratedCode]);

  const handleConfigChange = (newConfig) => {
    updateConfig(TOOL_TYPES.PHOTO_PICKER, newConfig);
  };

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4 text-gray-900 dark:text-white">Photo Picker Generator</h2>
      <PhotoPickerControls config={config} onChange={handleConfigChange} />
    </div>
  );
};

export const PhotoPickerPreviewComponent = () => {
  const config = useToolStore((state) => state.toolConfigs[TOOL_TYPES.PHOTO_PICKER]);
  return <PhotoPickerPreview config={config} />;
};

export default PhotoPickerGenerator;

